<script>
import Layout from "../../../layouts/auth";
import appConfig from "@/app.config";
import { email, required } from "vuelidate/lib/validators";
import { EMAIL_TO } from "@/services/api/auth";

export default {
  page: {
    title: "Lupa Kata Sandi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      message: "",
      invalidEmail: false,
    };
  },
  validations: {
    email: {
      required,
      email,
      invalidEmail: true,
    },
  },
  methods: {
    submitEmail() {
      this.$v.email.$touch();
      if (this.$v.email.$invalid) return;
      const input = {
        email: this.email,
      };
      this.$apollo
        .mutate({
          mutation: EMAIL_TO,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.emailForgotPassword.isSuccessful == false) {
            this.$toast.error(response.data.emailForgotPassword.message);
          } else if (
            response.data.emailForgotPassword.emailForgotPassword.message ==
            "failed to get email"
          ) {
            this.invalidEmail = true;
            setTimeout(() => {
              this.invalidEmail = false;
            }, 5000);
          } else {
            localStorage.setItem("emailOTP", this.email);
            this.$store.commit("resetPassword/SET_EMAIL", this.email);
            this.$router.push({ name: "OTP Verification" });
          }
        });
    },
  },
};
</script>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo mb-0 pt-5">
        <router-link to="/">
          <img src="@/assets/images/main-logo.png" alt />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">Lupa Kata Sandi ?</h4>
        <p>Silahkan masukkan email yang terdaftar, kami akan mengirimkan kode Verifikasi pada email tersebut.</p>
        <b-form @submit.prevent="submitEmail">
          <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="email"
              type="text"
              placeholder="Email"
              :class="{
                'is-invalid': $v.email.$error || invalidEmail,
              }"
            ></b-form-input>
            <div
              v-if="$v.email.$error || invalidEmail"
              class="invalid-feedback"
            >
              <span v-if="invalidEmail">Email tidak terdaftar. </span>
              <span v-if="!$v.email.required">Email tidak boleh kosong.</span>
              <span v-if="!$v.email.email">Format email tidak sesuai.</span>
            </div>
          </b-form-group>
          <div class="mt-5">
            <b-button type="submit" variant="primary" class="w-100"
              >Lanjut</b-button
            >
            <a
              class="text-primary d-block mt-3"
              @click="$router.push({ name: 'Login' })"
              >Kembali ke Halaman Masuk</a
            >
          </div>
        </b-form>
      </div>
      <div class="mc-auth__copyright">
        <span>Dipersembahkan oleh <img src="@/assets/images/copyright-logo.png" class="ms-2" alt height="18"></span>
      </div>
    </div>
  </Layout>
</template>
